import React, { useRef, useState } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import { useDispatch, useSelector } from "react-redux";
import { addTerm, fetchGlossary, saveGlossaryModifications, termSourceModified, termTargetModified, removeTerms } from "./../../redux/ducks/glossary";
import useStatusThunk from "../../hook/useStatusThunk";
import useEffectWithoutLoad from "../../hook/useEffectWithoutLoad";
import useAuthEffect from "../../hook/useAuthEffect";
import RouteHeader from "../../components/dumb/RouteHeader";
import { Row, Table } from "../../components/dumb/DataTable";
import LanguageSelect from "../../components/smart/LanguageSelect";
import SetGlossaryName from "../../components/smart/buttonPopups/SetGlossaryName";
import ExportGlossary from "../../components/smart/buttonPopups/ExportGlossary";
import TermNote from "../../components/smart/buttonPopups/TermNote";

const GlossaryRoute = ({ match }) => {

    const glossaryID = match.params.glossaryID;
    const dispatch = useDispatch();
    const glossary = useSelector(state => state.glossary.glossaries[glossaryID]);
    const [dispatchFetchGlossary, status, error] = useStatusThunk(fetchGlossary);
    const [rows, setRows] = useState([]);
    const [activeLang, setActiveLang] = useState(null);
    const [targetLangs, setTargetLangs] = useState([]);

    const activeLangRef = useRef();

    activeLangRef.current = activeLang;

    useAuthEffect(isAuth => dispatchFetchGlossary({ glossaryID }));

    useEffectWithoutLoad(() => {
        if (status == "success") {

            let langs = [];
            glossary.terms.forEach(term => {
                term.targets.forEach(target => {
                    if (!langs.includes(target.lang)) langs.push(target.lang);
                });
            });
            setTargetLangs(langs);

            setRows(glossary.terms.map((term, index) => {
                const target = term.targets.find(target => target.lang == activeLang);
                return {
                    ID: term.id,
                    index,
                    source: term.source,
                    target: target?.text,
                    targetModifiedBy: target?.modifiedBy,
                    targetModifiedDate: target?.modifiedDate,
                    modified: term?.modified
                }
            }));
        }
    }, [status, glossary?.terms, activeLang]);

    const sourceModified = (ID, text) => dispatch(termSourceModified({ termID: ID, glossaryID, sourceText: text }));
    const targetModified = (ID, text) => dispatch(termTargetModified({ termID: ID, glossaryID, targetText: text, targetLang: activeLangRef.current }));

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="glossaries" />
            </div>

            <div className="column column--primary">
                <RouteHeader title={<React.Fragment>{glossary?.name} <SetGlossaryName glossaryID={glossaryID}/></React.Fragment>} data={{ ID: glossaryID, note: glossary?.note, "source lang": glossary?.sourceLang, size: glossary?.size, created: glossary?.created }} />

                <Terms targetLangs={targetLangs} setTargetLang={setActiveLang} rows={rows} glossaryID={glossaryID} targetLang={activeLang} sourceLang={glossary?.sourceLang} termSourceModified={sourceModified} termTargetModified={targetModified} />
            </div>
        </div>
    )
}

const Terms = props => {
    const dispatch = useDispatch();

    const [checkValues, setCheckValues] = useState([]);

    const renderRow = (row, renderData, extra) => <React.Fragment>
        {renderData(row.ID, { key: "id" })}
        {extra.renderTextareaData(row.source, { key: "source", onInput: text => { props.termSourceModified(row.index, text) } })}
        {extra.renderTextareaData(row.target ? row.target : "", { key: "target", onInput: text => { props.termTargetModified(row.index, text) } })}
        {renderData(row.targetModifiedBy ? row.targetModifiedBy : "", { key: "targetModifiedBy" })}
        {renderData(row.targetModifiedDate ? row.targetModifiedDate : "", { key: "targetModifiedDate" })}
        {renderData(<TermNote termID={row.ID}/>, {key:"note"})}
    </React.Fragment>

    let titleContent = <React.Fragment>
        <ExportGlossary glossaryID={props.glossaryID} />
        <button className="button" onClick={() => { dispatch(addTerm({ glossaryID: props.glossaryID })) }}>Add</button>
        <button className={"button " + (checkValues.length == 0 ? "button--disabled" : "")} onClick={() => dispatch(removeTerms({ termIDs: checkValues, glossaryID: props.glossaryID }))}>Remove</button>
        <button className="button" onClick={() => dispatch(saveGlossaryModifications({ glossaryID: props.glossaryID }))}>Save</button>
        <LanguageSelect prioritize={props.targetLangs} value={props.targetLang} onChange={e => props.setTargetLang(e.target.value)} className="select select--primary title-content__select" />
    </React.Fragment>

    return (
        <Table checkbox={true} newCheckValues={setCheckValues} getCheckValue={row => row.ID} title="terms" titleContent={titleContent} renderRow={renderRow}
            rows={props.rows} cols={[
                { name: "id", sortCol: "ID" },
                { name: props.sourceLang, sortCol: "source" },
                { name: props.targetLang, sortCol: "target" },
                { name: "modified by", sortCol: "targetModifiedBy" },
                { name: "modified date", sortCol: "targetModifiedDate" },
                { name: "", style:{width:"1px"} }
            ]}

            getRowAttributes={row => ({
                className: "term-row " + (row.modified ? "term-row--modified" : "")
            })}
        />
    )
}

export default GlossaryRoute;